module.exports = {"radius":"4px","radiusHalf":"2px","radiusCircle":"50%"};